import React, { useState } from "react";
import styles from "../../styles/Select.module.css";

interface TextareaInputProps {
  label: string;
  value: string | undefined;
  onChange: (value: string) => void;
  disabled?: boolean;
  placeholder?: string;
  style?: React.CSSProperties;
  inputStyle?: React.CSSProperties;
  labelStyle?: React.CSSProperties;
  error?: string;
  rows?: number;
  border?: boolean;
}

export const TextareaInput: React.FC<TextareaInputProps> = ({
  label,
  value,
  onChange,
  disabled,
  placeholder = "Введіть текст",
  style,
  inputStyle,
  labelStyle,
  error,
  rows = 4,
}) => {
  const [focused, setFocused] = useState(false);
  const hasValue = value !== undefined && value !== "";
  const isFloating = focused || hasValue;

  return (
    <div className={styles.formControl} style={style}>
      <div className={styles.selectWrapper}>
        <textarea
          rows={rows}
          maxLength={250}
          className={styles.select}
          value={value ?? ""}
          disabled={disabled}
          placeholder={isFloating ? placeholder : ""}
          onChange={(e) => onChange(e.target.value)}
          onFocus={() => setFocused(true)}
          onBlur={() => setFocused(false)}
          style={{
            ...inputStyle,
            height: "auto",
            padding: "12px 14px",
            resize: "vertical",
            borderColor: error ? "var(--vivid-pink)" : undefined,
            width: "100%",
          }}
        />
        <label
          style={{
            position: "absolute",
            left: "10px",
            top: isFloating ? "-8px" : "14px",
            padding: "0 4px",
            fontSize: isFloating ? "12px" : "14px",
            color: focused ? "var(--blue)" : "var(--black)",
            background: isFloating
              ? "linear-gradient(to bottom, var(--background) 40%, white 60%)"
              : "transparent",
            pointerEvents: "none",
            zIndex: 1,
            fontWeight: isFloating ? 700 : 500,
            transition: "top 0.2s ease, font-size 0.2s ease, color 0.2s ease",
            whiteSpace: "nowrap",
            ...labelStyle,
          }}
        >
          {label}
        </label>
      </div>
      <div
        style={{
          color: "var(--vivid-pink)",
          fontSize: "11px",
          paddingLeft: "4px",
          height: "16px",
        }}
      >
        {error ?? null}
      </div>
    </div>
  );
};
